// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - no types available
import polyline from '@mapbox/polyline';

/**
 * Decode encoded polyline to array of [lon, lat] pairs
 * OSRM uses precision 5, Valhalla uses precision 6
 */
export function decodePolyline(encoded: string, precision: number = 5): [number, number][] {
  // polyline.decode returns [lat, lon] pairs, we need to swap to [lon, lat] for GeoJSON
  const decoded: [number, number][] = polyline.decode(encoded, precision);
  return decoded.map(([lat, lon]: [number, number]) => [lon, lat] as [number, number]);
}

/**
 * Decode polyline and return as GeoJSON LineString
 */
export function polylineToGeoJSON(encoded: string): GeoJSON.LineString {
  return {
    type: 'LineString',
    coordinates: decodePolyline(encoded),
  };
}

/**
 * Get a point on the polyline by index
 */
export function getPointOnPolyline(
  decoded: [number, number][],
  index: number
): { lon: number; lat: number } | null {
  if (index < 0 || index >= decoded.length) return null;
  const [lon, lat] = decoded[index];
  return { lon, lat };
}
